/**
 * List Schema of SaraivaCnpjDisponivel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivel} from '@/model/resource/SaraivaCnpjDisponivel'

/* TODO: review generated schema */
export class ListSaraivaCnpjDisponivelSchema extends Schema {
  readonly name = 'ListSaraivaCnpjDisponivel'

  readonly fieldSet: FieldSet<SaraivaCnpjDisponivel> = {
    id: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpjRaiz: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
